import { withStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';

import styles from '../styles/projections';
import getSubscriptionDetails from '../actions/getSubscriptionDetails';
import mapFeatures from '../actions/mapFeatures';
import StatusCell from '../../../partials/statusCell/StatusCell';
import pickOptionsForStatusCell from '../../../partials/statusCell/actions/pickOptionsForStatusCell';
import STATUS_BOX_OPTIONS from '../../../consts/statusBoxOptions';
import { CircularProgress } from '@material-ui/core';
import { doesArrayHasLength } from '../../../utils/isDefined';
import { translate } from '../../../i18n/I18nProvider';

const Features = ({ classes, clientId, subReference }) => {
  const [subDetails, setSubDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingComplete, setLoadingComplete] = useState(false);

  useEffect(() => {
    (async () => {
      let details = [];
      setLoadingComplete(false);
      setIsLoading(true);
      try {
        const data = await getSubscriptionDetails({ subReference, clientId });

        const features = mapFeatures({ features: data.features });

        details = features;
      } catch {
      } finally {
        setSubDetails(details);
        setIsLoading(false);
        setLoadingComplete(true);
      }
    })();
  }, [subReference, clientId]);

  return (
    <>
      {isLoading && (
        <div className={classes.loaderOverlay}>
          <CircularProgress size={30} />
        </div>
      )}
      {loadingComplete && doesArrayHasLength(subDetails) ? (
        <table className={classes.root}>
          <tbody>
            {subDetails.map(el => {
              const value = el.isBoolean ? (
                <StatusCell
                  isTable={false}
                  {...pickOptionsForStatusCell(
                    STATUS_BOX_OPTIONS.ENABLED,
                    el.value
                  )}
                />
              ) : (
                el.value
              );

              return (
                <tr key={el.label} className={classes.row}>
                  <td className={classes.severity}>{el.label}</td>
                  <td className={classes.cell}>{value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className={classes.noFeatures}>
          {translate('SUBSCRIPTIONS.NO_FEATURES')}
        </div>
      )}
    </>
  );
};

const mapStatesToProps = ({ selectClient }) => {
  return {
    clientId: selectClient.selectedClient.id
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(Features);
